<span v-if="!renderAsLink" :class="getClass">{{ getModel }}</span><a v-else :href="getHref">{{ getModel }}</a>